import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import {  apiSignOut, apiSignUp } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import axios from 'axios'

function useAuth() {

    const dispatch = useDispatch()

    const navigate = useNavigate()

	const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.session)

    const signIn = async (values) => {
        try {
			const resp = await axios.post(`${process.env.REACT_APP_API_URL}/index.php/api/Users_temp/loginDashboard`, {
				username :values.mobile_number,
				password:values.password
			}
			)
			if (resp.data) {
				const { token } = resp.data
				if(resp.data.response_message === 'Login Successfully'){

				dispatch(onSignInSuccess(token))
				localStorage.setItem('isAuthenticated', true);
				// if(resp.data.user_data) {
				// 	dispatch(setUser(resp.data.user_data || { 
				// 		avatar: '', 
				// 		userName: 'Anonymous', 
				// 		authority: ['USER'], 
				// 		email: ''
				// 	}))
				// }
				const redirectUrl = query.get(REDIRECT_URL_KEY)
				navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)
                return {
                    status: 'success',
                    message: ''
                }
			}else {
				return {
					status: 'failed',
					message: resp.data?.response_message
				}
			}
			
			}else {
				return {
					status: 'failed',
					message: resp.data?.response_message
				}
			}
		} catch (errors) {
			return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString()
            }
		}
    }

	const signUp = async (values) => {
        try {
			const resp = await apiSignUp(values)
			if (resp.data) {
				const { token } = resp.data
				dispatch(onSignInSuccess(token))
				if(resp.data.user) {
					dispatch(setUser(resp.data.user || { 
						avatar: '', 
						userName: 'Anonymous', 
						authority: ['USER'], 
						email: ''
					}))
				}
				const redirectUrl = query.get(REDIRECT_URL_KEY)
				navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)
                return {
                    status: 'success',
                    message: ''
                }
			}
		} catch (errors) {
			return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString()
            }
		}
    }

    const handleSignOut = ()  => {
		dispatch(onSignOutSuccess())
		localStorage.removeItem('isAuthenticated')
		dispatch(setUser(initialState))
		navigate(appConfig.unAuthenticatedEntryPath)
	}

    const signOut =  () => {
		handleSignOut()
	}
    const authUser = localStorage.getItem('isAuthenticated')

	
    return {
        // authenticated: token && signedIn,
        authenticated:  signedIn || authUser,
        signIn,
		signUp,
        signOut
    }
}

export default useAuth